function loadImage(el) {
  if (el.getAttribute('data-lazy-loaded')) {
    // Do nothing;
  } else {
    el.setAttribute('data-lazy-loaded', true);
    let img = new Image();
    let src = el.getAttribute('data-src');
    img.onload = function () {
      el.src = src;
    };
    img.src = src;
  }
}

function loadBackground(el) {
  if (el.getAttribute('data-lazy-loaded')) {
    // Do nothing;
  } else {
    el.setAttribute('data-lazy-loaded', true);
    let img = new Image();
    let src = el.getAttribute('data-url');
    img.onload = function () {
      let backgroundStyle = el.getAttribute('data-background');
      backgroundStyle = `${backgroundStyle} url('${src}')`;
      el.style.background = backgroundStyle;
    };
    img.src = src;
  }
}
// Do not remove this will use it in future to only load images in viewport
// function elementInViewport(el) {
//   let rect = el.getBoundingClientRect();
//   return (
//     rect.top    >= 0
//     && rect.left   >= 0
//     && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
//   )
// }

export default function lazyLoad(elements, options = {}) {
  for (let i = 0; i < elements.length; i++) {
    if (options.background) loadBackground(elements[i]);
    else loadImage(elements[i]);
  }
}
